<mp-autocomplete
  #unitAutocomplete
  [(selectedValue)]="selectedValue"
  [options]="filteredOptions()"
  [optionTemplate]="optionTemplate"
  [clearable]="true"
  [inline]="true"
  appearance="standard"
  autocompleteIcon="straighten"
  placeholder="Einheit zuweisen"
  (selectedValueChange)="onSelectChange($event)"
  (searchTermChange)="onSearchTermChange($event)"
>
  <ng-template #optionTemplate mpTypedTemplate [contextType]="unitAutocomplete.optionTemplateContextType" let-option>
    <div class="mp-packungseinheiten-selector__option">
      <span class="font-bold">{{ option.value.shortName }}</span> ({{ option.value.longName }})
    </div>
  </ng-template>
</mp-autocomplete>
